import React, { memo } from "react"
import { t } from "ttag"

import * as Styles from "./ScheduledSurveyQuestionGeneralResults.styles"
import { SkinnyScheduledChoiceStatistics } from "models/SkinnyScheduledChoiceStatistics"

type NpsGroup = {
  label: string,
  choices: SkinnyScheduledChoiceStatistics[],
}

const getNpsGroups = (choices: SkinnyScheduledChoiceStatistics[]): NpsGroup[] => {
  const detractors = choices.filter(({ choice }) => choice.satisfactionValue <= 6)
  const passives = choices.filter(({ choice }) => choice.satisfactionValue >= 7 && choice.satisfactionValue <= 8)
  const promoters = choices.filter(({ choice }) => choice.satisfactionValue >= 9)

  return [
    { choices: detractors, label: t`Detractors:` },
    { choices: passives, label: t`Passives:` },
    { choices: promoters, label: t`Promoters:` },
  ]
}

const NpsBarGroups: React.FC<NpsBarGroupsProps> = ({ choicesWithStatistics }) => {
  const groups = getNpsGroups(choicesWithStatistics)

  return (
    <>
      {groups.map(({ label, choices }) => (
        <Styles.NpsGroup key={label}>
          <Styles.NpsGroupLabel>{label}</Styles.NpsGroupLabel>
          {choices.map(({ choice, selectionPercentage }) => (
            <Styles.StatisticsBar
              key={choice.id}
              label={choice.name}
              value={selectionPercentage}
              unit="%"
            />
          ))}
        </Styles.NpsGroup>
      ))}
    </>
  )
}

interface NpsBarGroupsProps {
  choicesWithStatistics: SkinnyScheduledChoiceStatistics[],
}

export default memo(NpsBarGroups)
